/*!
* name ZJX 产品分享
* Copyright 2018-2019
*/
<template>
  <div>
    <publicBanner :imgList="imgList"></publicBanner>
    <div class="resourcedownloading_content">
      <div class="resourcedownloading_tab_title">
        <span style="cursor: pointer;" @click="$router.push('/sharingcenter')">乐画</span> >
        <span style="color: #0000ee;">作品列表</span>
      </div>
      <div class="resourcedownloading_tab_box">
        <ul class="resourcedownloading_tab_box_list">
          <template v-if="dataList&&dataList.length>0">
            <li
              class="resourcedownloading_tab_box_list_li"
              v-for="(item,index) in dataList"
              :key="index" @click="goSharingcenterdetails(item)">
              <div class="resourcedownloading_tab_box_list_img">
                <img :src="item.avatar" alt>
              </div>
              <div class="resourcedownloading_tab_box_list_text">
                <div class="resourcedownloading_tab_box_list_one">
                  <div style="height:40px;">
                    <img
                      class="resourcedownloading_tab_box_list_one_img"
                      :src="item.author.avatar"
                      alt
                    >
                    <span class="resourcedownloading_tab_box_list_one_span">{{item.title}}</span>
                    <span
                      class="resourcedownloading_tab_box_list_el"
                    >{{item.is_student_created == 0? '老师作品' : '学生作品'}}</span>
                  </div>
                  <span style="color:#a8a8a8">创作者：{{item.author.name}}</span>
                </div>
                <div class="resourcedownloading_tab_box_list_two">
                  <div class="resourcedownloading_tab_box_list_icon">
                    <img src="../../assets/images/grade.png" alt>
                    <span style="margin-left:8px;">{{item.type_name}}</span>

                    <img v-if="item.is_student_created != 0" style="margin-left:30px;"
                         src="../../assets/images/star.png"
                         alt>
                    <span v-if="item.is_student_created != 0" style="margin-left:8px;">评分：{{item.score_num!=null?item.score_num:10}}分</span>

                    <img v-if="item.is_thumb_up == true" style="margin-left:30px;" @click.stop="doYouLike(item,index)"
                         src="../../assets/images/dianzan.png" alt>
                    <img v-else style="margin-left:30px;" @click.stop="doYouLike(item,index)"
                         src="../../assets/images/zan.png" alt>
                    <span style="margin-left:8px;">{{item.thumb_up_num}}</span>
                  </div>
                  <div>{{item.comment}}</div>
                </div>
                <div class="resourcedownloading_tab_box_list_san">分享于 {{item.shared_at}}</div>
              </div>
            </li>
          </template>
          <template v-else>
            <div
              style="display: flex;justify-content: center; align-items: center;width: 100%;height: 100px;font-size: 16px;color: #8c939d;">
              暂无数据
            </div>
          </template>
        </ul>
      </div>
      <div class="sharingcenter_paging">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="totalData"
          @current-change="pageNumberChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex' //引入全局vuex
import publicBanner from '@/components/publicBanner' //引入尾部
import cacheUtils from '@/common/cacheUtils' //调用缓存
import apiInterface from '@/api/index' //接口
export default {
  data () {
    return {
      imgList: [
        {
          id: 1,
          src:
            "http://lehuawang.dzhhb.com/imgs/banner0011.png"
        },
        {
          id: 2,
          src:
            "http://lehuawang.dzhhb.com/imgs/banner0021.png"
        },
        {
          id: 3,
          src:
            "http://lehuawang.dzhhb.com/imgs/banner0031.png"
        }
      ], //存放img列表的数组
      dataList: [], //初始化列表数据
      totalData: 0, //数据总数
      pageSize: 5 //每页条数
    }
  },
  computed: {},
  mounted () {},
  components: {
    publicBanner
  },
  created () {
    this.getSharingcenterData()
  },
  methods: {
    //初始化获取作品列表
    async getSharingcenterData (pages = 1) {
        debugger
      try {
        let pdata = await this.$xhr.get(apiInterface.worksList, {
          params: { page: pages }
        })
        this.dataList = pdata.data
        this.totalData = pdata.meta.pagination.total
      } catch (error) {
        console.log(error)
//        if(error.status_code == 403){
//          cacheUtils.cookie.clear()
//          cacheUtils.localStorage().clear()
//          cacheUtils.sessionStorage().clear()
//          window.location.href = 'http://' + document.domain
//        }
        this.$message.error(error.message)
      }
    },
    //分页
    pageNumberChange (pageNumber) {
      this.getSharingcenterData(pageNumber)
    },
    //跳转到分享详情页
    goSharingcenterdetails (item) {
      if (cacheUtils.cookie.getObject('Token') == null) {
        this.$router.push({ path: '/' })
        return
      } else {
        this.$router.push({
          path: '/sharingcenterdetails',
          query: {
            id: item.id,
          }
        })
      }
    },
    //点赞
    //点赞方法
    doYouLike (item, index) {
      if (cacheUtils.cookie.getObject('Token') == null) {
        this.$router.push({ path: '/' })
        return
      } else {
        if (this.dataList[index].is_thumb_up == true) {
          this.clearThumbsUp(item, index)
          this.dataList[index].is_thumb_up = false
        } else {
          this.thumbsUp(item, index)
          this.dataList[index].is_thumb_up = true
        }
      }
    },
    //资源点在取消接口
    async clearThumbsUp (item, index) {
      try {
        let pdata = await this.$xhr.post(
          apiInterface.worksThumbUp + item.id + '/thumb-up-remove'
        )
        this.dataList[index].thumb_up_num -= 1
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    //资源点赞接口
    async thumbsUp (item, index) {
      try {
        let pdata = await this.$xhr.post(
          apiInterface.worksThumbUp + item.id + '/thumb-up'
        )
        this.dataList[index].thumb_up_num += 1
      } catch (error) {
        this.$message.error(error.message)
      }
    },
  },
  watch: {
    $route (val, oldval) {}
  },
  props: {}
}
</script>

<style lang="scss">
.resourcedownloading_content {
  box-sizing: border-box;
  padding-top: 480px;
  padding-left: 20px;
  padding-right: 20px;

  .resourcedownloading_tab_title {
    box-sizing: border-box;
    line-height: 15px;
  }

  .resourcedownloading_tab_box {
    .resourcedownloading_tab_box_list {
      box-sizing: border-box;

      .resourcedownloading_tab_box_list_li {
        height: 280px;
        border-bottom: 1px solid #f0f0f0;
        padding-top: 30px;
        padding-bottom: 30px;
        box-sizing: border-box;
        cursor: pointer;

        .resourcedownloading_tab_box_list_img {
          width: 300px;
          height: 220px;
          float: left;

          img {
            width: 300px;
            height: 220px;
            border-radius: 4px;
          }
        }

        .resourcedownloading_tab_box_list_text {
          width: calc(100% - 300px);
          /*width: 660px;*/
          height: 220px;
          float: left;
          box-sizing: border-box;
          padding-left: 20px;

          .resourcedownloading_tab_box_list_one {
            height: 70px;

            .resourcedownloading_tab_box_list_one_img {
              width: 32px;
              height: 32px;
              border-radius: 50%;
              float: left;
            }

            .resourcedownloading_tab_box_list_one_span {
              font-size: 20px;
              font-weight: 600;
              float: left;
              margin-left: 10px;

              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              line-height: 25px;
              max-height: 25px;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              width: 528px;
            }

            .resourcedownloading_tab_box_list_el {
              float: right;
              width: 70px;
              background: #15c1e4;
              text-align: center;
              color: #fff;
              line-height: 26px;
              border-radius: 10px;
            }
          }

          .resourcedownloading_tab_box_list_two {
            height: 120px;

            .resourcedownloading_tab_box_list_icon {
              height: 52px;

              img {
                width: 20px;
                height: 20px;
                margin-top: 0px;
                float: left;
              }

              span {
                float: left;
              }
            }
          }

          .resourcedownloading_tab_box_list_san {
            box-sizing: border-box;
            padding-top: 10px;
            font-size: 14px;
            color: #818181;
          }
        }
      }
    }
  }
}

.sharingcenter_paging {
  height: 158px;
  text-align: center;
  box-sizing: border-box;
  padding-top: 30px;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #15c1e4;
}
</style>

